import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useTranslation } from "react-i18next";
import {
  $PageHeader,
  $Divider,
  $Affix,
  $Breadcrumb,
} from "us.common/components";
import * as Action from "us.common/actions";
import { useField } from "formik";
import {
  AddPostalArea,
  SelectMunicipal,
  SelectPostalArea,
} from "us.common/components";
import { PostalCodesActions } from "us.common/components/EntitySelection/Component";
import { useNavigate, useLocation } from "react-router-dom";
import { useReplaceNavigate } from "us.helper/hooks/customHooks/replaceHook/Home";

const PostalArea: React.FC<any> = (props) => {
  const { t } = useTranslation();
  const {
    name = "selectedPostalCodes",
    updateDrawerName,
    multiple,
    postalAreaClose,
    onSubmitSelection,
    countryCode,
    existingCode,
    updateFormData,
    deletePostalArea,
  } = props;
  const navigate = useNavigate();
  const replace = useReplaceNavigate();
  const { search, pathname } = useLocation();
  const urlParams = new URLSearchParams(search);
  const action = urlParams.get("action");
  const [isEditAction, setIsEditAction] = useState(false);
  const [field, ,] = useField(name);
  const [selectedPostalCodes, setSelectedPostalCodes] = useState<Array<any>>(
    []
  );
  const [changeDrawerView, setchangeDrawerView] = useState({
    selectPostalAreaView: true,
    addPostalAreaView: false,
    selectMunicipalesView: false,
  });
  const [municipleData, setMunicipleData] = useState({});
  const onClickSelectPostalArea = () => {
    setchangeDrawerView({
      selectPostalAreaView: true,
      addPostalAreaView: false,
      selectMunicipalesView: false,
    });
  };
  const onClickAddPostalArea = () => {
    setchangeDrawerView({
      selectPostalAreaView: false,
      addPostalAreaView: true,
      selectMunicipalesView: false,
    });
  };
  const onClickSelectMuniciples = () => {
    setchangeDrawerView({
      selectPostalAreaView: false,
      addPostalAreaView: false,
      selectMunicipalesView: true,
    });
  };

  const selectMunicipleDetails = (data: any) => {
    setMunicipleData(data);
    onClickAddPostalArea();
  };

  useEffect(() => {
    let codesArray: any = [];
    field.value?.map((val: any) => {
      codesArray.push(val.postalCode);
    });
    field.value?.length && setSelectedPostalCodes(field.value);
  }, []);

  const handleReplaceUrl = (action: string) => {
    const searchParams = new URLSearchParams();
    searchParams.set("action", action);

    navigate({
      pathname: pathname,
      search: searchParams.toString(),
    }, { replace: true });
  };

  const handlePostalAreaAction = (action: PostalCodesActions, data: any) => {
   // handleReplaceUrl(action);
    updateFormData({
      ...existingCode,
      ...data,
      municipalityName: data?.countyName,
      municipalityCode: data?.countyCode,
    });
    switch (action) {
      case PostalCodesActions.EDIT:
        setIsEditAction(true)
        setchangeDrawerView({
          selectPostalAreaView: false,
          addPostalAreaView: true,
          selectMunicipalesView: false,
        });
        break;
      case PostalCodesActions.DELETE:
        deletePostalArea && deletePostalArea({
          data,
          countryCode: countryCode ?? "",
        });
        setchangeDrawerView({
          selectPostalAreaView: true,
          addPostalAreaView: false,
          selectMunicipalesView: false,
        });
        break;
      default:
        break;
    }
  };

  return (
    <>
      {changeDrawerView.selectPostalAreaView ? (
        <>
          <SelectPostalArea
            {...props}
            name={name}
            selectedPostalCodes={selectedPostalCodes}
            multiple={multiple}
            onSelect={(selectedKeys: Array<any>) =>
              setSelectedPostalCodes(selectedKeys)
            }
            onSubmitSelection={(selectedKeys: Array<any>) =>
              onSubmitSelection && onSubmitSelection(selectedKeys)
            }
            onClickAddPostalArea={() => onClickAddPostalArea()}
            postalAreaClose={() => postalAreaClose && postalAreaClose()}
            onCallAction={handlePostalAreaAction}
            setIsEditAction ={setIsEditAction}
          />
        </>
      ) : null}
      {changeDrawerView.addPostalAreaView ? (
        <>
          <$Breadcrumb>
            <$Breadcrumb.Item onClick={() => onClickSelectPostalArea()}>
              <a href="#">{t("COMMON.SELECT_POSTAL_AREA")}</a>
            </$Breadcrumb.Item>
            <$Breadcrumb.Item>
              {isEditAction
                ? t("US.COLLECTION.COMMON:ENTITYSELECTION.UPDATE_POSTAL_AREA")
                : t("US.COLLECTION.COMMON:ENTITYSELECTION.NEW_POSTAL_AREA")}
            </$Breadcrumb.Item>
          </$Breadcrumb>
          <$Affix offsetTop={80}>
            <div className="page-header">
              <div className="d-flex align-items-center">
                <$PageHeader
                  className="px-0 py-0 mr-n3"
                  onBack={() => {
                    onClickSelectPostalArea();
                    updateDrawerName(
                      isEditAction
                        ? t(
                            "US.COLLECTION.COMMON:ENTITYSELECTION.UPDATE_POSTAL_AREA"
                          )
                        : t(
                            "US.COLLECTION.COMMON:ENTITYSELECTION.NEW_POSTAL_AREA"
                          )
                    );
                  }}
                  title={
                    isEditAction
                      ? t(
                          "US.COLLECTION.COMMON:ENTITYSELECTION.UPDATE_POSTAL_AREA"
                        )
                      : t(
                          "US.COLLECTION.COMMON:ENTITYSELECTION.NEW_POSTAL_AREA"
                        )
                  }
                />
              </div>
            </div>
          </$Affix>
          <$Divider className="mt-2" />
          <AddPostalArea
            {...props}
            onClickSelectMuniciples={() => onClickSelectMuniciples()}
            onCancelClick={() => onClickSelectPostalArea()}
            municipleData={municipleData}
            isEditAction = {isEditAction}
          />
        </>
      ) : null}
      {changeDrawerView.selectMunicipalesView ? (
        <>
          <$Breadcrumb>
            <$Breadcrumb.Item onClick={() => onClickSelectPostalArea()}>
              <a href="#">{t("COMMON.SELECT_POSTAL_AREA")}</a>
            </$Breadcrumb.Item>
            <$Breadcrumb.Item
              onClick={() => {
                onClickAddPostalArea();
                updateDrawerName(
                  isEditAction
                    ? t(
                        "US.COLLECTION.COMMON:ENTITYSELECTION.UPDATE_POSTAL_AREA"
                      )
                    : t("US.COLLECTION.COMMON:ENTITYSELECTION.NEW_POSTAL_AREA")
                );
              }}
            >
              <a href="#">
                {isEditAction
                  ? t("US.COLLECTION.COMMON:ENTITYSELECTION.UPDATE_POSTAL_AREA")
                  : t("US.COLLECTION.COMMON:ENTITYSELECTION.NEW_POSTAL_AREA")}
              </a>
            </$Breadcrumb.Item>
            <$Breadcrumb.Item>
              {t("COMMON.SELECT_MUNICIPALITY_NAME")}
            </$Breadcrumb.Item>
          </$Breadcrumb>
          <$Affix offsetTop={80}>
            <div className="page-header">
              <div className="d-flex align-items-center">
                <$PageHeader
                  className="px-0 py-0 mr-n3"
                  onBack={() => {
                    onClickAddPostalArea();
                    updateDrawerName(
                      t("US.COLLECTION.COMMON:ENTITYSELECTION.NEW_POSTAL_AREA")
                    );
                  }}
                  title={t(
                    "US.COLLECTION.COMMON:ENTITYSELECTION.SELECTMUNICIPALITYNAME"
                  )}
                />
              </div>
            </div>
          </$Affix>
          <$Divider className="mt-2 mb-3" />
          <SelectMunicipal
            {...props}
            onCancelClick={() => onClickAddPostalArea()}
            selectMunicipleDetails={(data: any) => selectMunicipleDetails(data)}
            countryCode={countryCode}
          />
        </>
      ) : null}
    </>
  );
};

const mapStateToProps = (state: any) => {
  const { entityDetails } = state;
  const { existingCode } = entityDetails;
  return { existingCode };
};

const mapDispatchToProps = {
  updateDrawerName: Action.entity.ChangePostalDrawerTitle,
  updateFormData: Action.entity.PostalCodeFormData,
  deletePostalArea: Action.postalAreas.deletePostalArea.delete,
};

export default connect(mapStateToProps, mapDispatchToProps)(PostalArea);
